/** @jsxImportSource @emotion/react */

import React from "react";
import { useUIStore } from "../../hooks/useUIStore";

interface NewMessageProps {
  message: string;
}

const styles = {
  message: {
    backgroundColor: "#0000000D",
    border: "1px solid #D804B6",
    padding: "20px 30px",
    borderRadius: "10px",
    textAlign: "center" as "center",
    position: "absolute" as "absolute",
    top: 64,
    right: 28,
    zIndex: Number.MAX_VALUE,
  },
  closeBtn: {
    position: "absolute" as "absolute",
    top: "1px",
    right: "10px",
    cursor: "pointer",
    color: "#D804B6",
  },
};

const NewMessage: React.FC<NewMessageProps> = ({ message }) => {
  const { isNewMessageOpen, closeNewMessage } = useUIStore();

  return isNewMessageOpen ? (
    <div css={[styles.message]}>
      {message}
      <span css={styles.closeBtn} onClick={closeNewMessage}>
        x
      </span>
    </div>
  ) : null;
};

export default NewMessage;
